import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import { refetchUserOnError } from "utils/refetchUserOnError";

type MentionNotificationData = {
  issueId: string;
  mentionedBy: string;
  mentions: string[];
};

const sendMentionNotification = async (
  payload: MentionNotificationData
): Promise<void> => {
  await customAxios.post<void>(`/comments/notifications/mentions`, payload);
};

export const useCreateMentionNotification = (
  onSuccessCallback?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, MentionNotificationData>({
    mutationFn: sendMentionNotification,
    onSuccess: async () => {
      await queryClient.invalidateQueries(["mentions"]);

      showNotification({
        title: "Notification Sent",
        message: "Users have been notified of your mention.",
        color: "teal",
      });

      onSuccessCallback?.();
    },
    onError: (error) => {
      showNotification({
        title: "Error",
        message: "Failed to send mention notifications. Please try again.",
        color: "red",
      });
      refetchUserOnError(error, queryClient);
    },
  });
};
